import { makeStyles } from 'tss-react/mui'
import BgImage from 'src/assets/images/graidentBackground.jpg'
import { nunito_sans } from '@styles/fonts'

const useStyles = makeStyles()((theme) => ({
  root: {
    width: '100%',
    height: 'auto',
    backgroundImage: `url(${BgImage?.src})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: theme.spacing(8, 0, 0),
    marginBottom: theme.spacing(20),

    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(4, 0, 0),
      marginBottom: theme.spacing(10),
    },
  },
  headingContainer: {
    padding: '51px 0 30px 0', // ? figma values
    textAlign: 'center',
    fontFamily: 'Nunito Sans',
    fontStyle: 'normal',
    fontWeight: 800,
    fontSize: '48px',
    lineHeight: '83px',
    textTransform: 'uppercase',
  },
  authLink: {
    padding: theme.spacing(4, 0),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.7, 0),
    },
  },

  link: {
    color: theme.custom.blackColor,
  },
  header: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '48px',
    textAlign: 'center',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(5),
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    [theme.breakpoints.down('md')]: {
      fontSize: '24px',
    },
  },
  createLink: {
    fontFamily: nunito_sans.style.fontFamily,
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '18px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: theme.custom.blackColor,
    a: {
      color: theme.custom.blackColor,
    },
    padding: theme.spacing(6, 4, 0),
  },

  bottomGradient: {
    height: '100px',
    width: '100%',

    background:
      'linear-gradient(180deg, #FFFFFF 0%, rgba(255, 255, 255, 0) 0.01%, #FFFFFF 100%)',
  },
}))

export default useStyles
